import { SKIPPED } from '@datadog/browser-core';
import { RumEventType } from '@datadog/browser-rum-core';
export var startProfilingContext = function startProfilingContext(hooks) {
  // Default status is `starting`.
  var currentContext = {
    status: 'starting'
  }; // Register the assemble hook to add the profiling context to the event attributes.

  hooks.register(0
  /* HookNames.Assemble */
  , function (_ref) {
    var eventType = _ref.eventType;

    if (eventType !== RumEventType.VIEW && eventType !== RumEventType.LONG_TASK) {
      return SKIPPED;
    }

    return {
      type: eventType,
      _dd: {
        profiling: currentContext
      }
    };
  });
  return {
    get: function get() {
      return currentContext;
    },
    set: function set(newContext) {
      currentContext = newContext;
    }
  };
};